import React from "react";
import CaroselloStandard from "../commons/CaroselloStandard";
import foto1 from "../images/Palestra/IMG_9287.jpg"
import foto2 from "../images/Palestra/IMG_9288.jpg"
import foto3 from "../images/Palestra/IMG_9289.jpg"
import foto4 from "../images/Palestra/IMG_1287.jpg"
import Titolo from "../commons/Titolo";
import PalestraAccordion from "../components/palestra/PalestraAccordion";
import ScrollToTopOnMount from "../components/ScrollToTopOnMount";
import Space from "../commons/Space";
import CardMultitessere from "../components/CardMultitessere";
import TitoloSezioni from "../commons/TitoloSezioni";
import CardInEvidenza from "../components/CardInEvidenza";
import promo from "../images/News/Promo_fine_stagione.png";
import CardNewsEvidenza from "../components/CardNewsEvidenza";
import barista from "../images/News/Barista.png";
import SpaceL from "../commons/SpaceL";


function Palestra() {
    return(
        <div>
            <ScrollToTopOnMount />
            <Titolo backgroundImage={foto1} title={"Palestra"}/>
            <Space />
            <div style={{padding: "1em"}}>

            <PalestraAccordion />
            <Space />
            <figure className="text-center">
                <blockquote className="blockquote">
                    <p>
                        Accesso libero ai due ambienti: <strong>sala cardio</strong> e <strong>sala pesi</strong>
                        <br/>
                        <strong>Scheda personalizzata</strong> per tutti gli iscritti
                        <br/>
                        Personale di sala sempre presente
                        <br/>
                        <br/>
                        <span className="fw-bold" style={{width: "18px"}}> Gruppo organizzato giovanissimi</span>
                        <hr className="m-auto" style={{maxWidth: "16em"}}/>
                        <span style={{fontSize: "16px"}}>
                        11-14 anni
                        <br/>Martedì e venerdì dalle 17 alle 18
                        <br/>
                            </span>
                        <SpaceL />
                        <span className="fw-bold">Allenamento al femminile</span><br className="d-block d-sm-none"/> con Loredana
                        <span style={{fontSize: "16px"}}>
                        <hr className="m-auto" style={{maxWidth: "18em"}}/>
                        Lezioni individuali a corpo libero per migliorare mobilità articolare, flessibilità, forza e resistenza
                        <br/>Pacchetto 10 lezioni da 60 minuti: 300€
                        <br/>Pacchetto 10 lezioni per due persone da 60 minuti: 400€
                        <br/> Per una prova gratuita scrivi a <span/>
                       <a style={{color: "grey"}} title="mailto:loredanatraining@gmail.com" href="mailto:loredanatraining@gmail.com">loredanatraining@gmail.com</a>
                        </span>

                    </p>
                </blockquote>
            </figure>
            <Space />
                <CaroselloStandard foto1={foto1} foto2={foto2} foto3={foto3} foto4={foto4}/>
            <Space />
            <div className="d-flex flex-column text-center align-items-center justify-content-center">
                <TitoloSezioni title={"Multitessere"} />
                <h4 style={{fontFamily: "Hammersmith One"}}>Scopri le nostre multitessere</h4>
                <CardMultitessere />
            </div>
                <Space />

            <Space />
            </div>
        </div>
    )
}


export default Palestra
